import styled from 'styled-components'
import { colors } from 'styles'

const StyledStaticPage = styled.section`
  h2,
  strong {
    color: ${colors.textSectionTitle};
  }

  a {
    color: inherit;
  }

  h2 {
    font-size: 2rem;
    margin: 1.6rem 0;
  }

  p,
  li {
    font-size: 1.4rem;
    line-height: 1.5;
    margin: 1.6rem 0;
  }
`

export default StyledStaticPage
